import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { UserPromoteToPartner, UserPromoteToPartnerResponse } from 'types/api'
import { BaseParams } from 'types/utils'

export function usePromoteToPartner() {
  const queryClient = useQueryClient()

  async function promoteToPartner({
    body
  }: BaseParams<UserPromoteToPartner, 'POST'>) {
    const response = await apiClient.post<UserPromoteToPartnerResponse>(
      SNA_PREFIX + 'partners/promote',
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: promoteToPartner,
    onSuccess: () => {
      // Invalidate partner list to refresh data
      queryClient.invalidateQueries({ queryKey: ['partners'] })
      // Also invalidate all partner-related queries
      queryClient.invalidateQueries({
        predicate: (query) =>
          Array.isArray(query.queryKey) && query.queryKey[0] === 'partners'
      })
    }
  })
}
